import {deleteOrderItems} from "./deleteOrderItems";

export const deleteOrderItem = (orderItemId: string) => {
    deleteOrderItems([orderItemId]);
};
